export enum ClientOrderSubmissionState {
  COMPLETED = 'COMPLETED',
  PARTIAL = 'PARTIAL',
  UNKNOWN = 'UNKNOWN',
}
